import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../strings.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  _ExcelLikeFormula___init__impl__5newgny7l2ajw10exm as _ExcelLikeFormula___init__impl__5newgn,
  ExcelLikeFormula3nl4zwq7og62 as ExcelLikeFormula,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/excel.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { CareDayInfoWithSubsidies1r6eshq91lm1r as CareDayInfoWithSubsidies } from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/excelInputs.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializer1hwzc6m64v1op as serializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { default1jaun537xukbl as default_0 } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Defaults.mjs';
import { PrimitiveClasses_getInstance13wbaztpz3e2d as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { formulaBuilderqnttj5yf43zm as formulaBuilder } from './components/formulaTester.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ExcelFormulaLabPage$_get_title_$lambda_d9ppwp($this$remember) {
  return $this$remember.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_navFormulaLabTitle_ewi7uf_k$();
}
var ExcelFormulaLabPageClass;
function ExcelFormulaLabPage() {
  if (ExcelFormulaLabPageClass === VOID) {
    class $ {
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, ExcelFormulaLabPage$_get_title_$lambda_d9ppwp);
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        var formula = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(new (ExcelLikeFormula())(_ExcelLikeFormula___init__impl__5newgn('0')));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
        ensureOutermostElement(element);
        _this__u8e3s4.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        // Inline function 'org.thecommunitygroupinc.cares.views.components.formulaBuilder' call
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_0 = serializer(createKType(getKClass(CareDayInfoWithSubsidies()), arrayOf([]), false));
        var tmp$ret$5 = isInterface(this_0, KSerializer()) ? this_0 : THROW_CCE();
        var testValues = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(default_0(tmp$ret$5));
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_1 = serializer(createKType(getKClass(CareDayInfoWithSubsidies()), arrayOf([]), false));
        var tmp = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer(createKType(PrimitiveClasses_getInstance().get_doubleClass_dahzcy_k$(), arrayOf([]), false));
        var tmp$ret$9 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        formulaBuilder(element, tmp, tmp$ret$9, formula, testValues);
        element.onStartup_vrxh3i_k$();
        _this__u8e3s4.addChild_2qpft2_k$(element);
      }
    }
    initMetadataForClass($, 'ExcelFormulaLabPage', ExcelFormulaLabPage, VOID, [Page()]);
    ExcelFormulaLabPageClass = $;
  }
  return ExcelFormulaLabPageClass;
}
//region block: exports
export {
  ExcelFormulaLabPage as ExcelFormulaLabPage2bthkhkor66sr,
};
//endregion

//# sourceMappingURL=ExcelFormulaLab.mjs.map
